import App from './App.svelte';
import './assets/css/reset.scss';
import './assets/css/spacing.scss';
import './assets/css/absoluteSpacing.scss';
import './assets/css/size.scss';
import './assets/css/helper.scss';
import './assets/css/color.scss';
import './assets/css/custom.scss';
import './assets/css/storefront.scss';
import { captureLabelScan } from './assets/js/siteAnalytics.js';

// Before anything reads the URL: a label QR (/l/<code>) is swapped for the menu link.
captureLabelScan();

const app = new App({
	target: document.body,
});

export default app;
